import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import LoginPage from '../pages/LoginPage'
import SubscriptionPage from '../pages/SubscriptionPage'
import HomePage from '../pages/HomePage'
import AllQuizes from '../pages/AllQuizes'
import QuizDetails from '../pages/QuizDetails'
import Leaderboard from '../pages/Leaderboard'
import Profile from '../pages/Profile'
import ContactUs from '../pages/ContactUs'
import Policy from '../pages/Policy'
import Language from '../pages/Language'
import EditProfile from '../pages/EditProfile'
import History from '../pages/History'
import FindingOpponent from '../pages/FindingOpponent'
import Game from '../pages/Game'
import GameOver from '../pages/GameOver'
import ErrorBoundary from '../pages/ErrorBoundary'
import OtpPage from '../pages/OtpPage'
import ReverseQuizGame from "../pages/ReverseQuizGame"
import ReverseQuizGameOver from "../pages/ReverseQuizGameOver"
import FindingOpponentReverseQuiz from "../pages/FindingOpponentReverseQuiz"
import ReverseQuizPage from "../pages/ReverseQuizPage";
import LowBalancePage from '../pages/LowBalancePage'
import Auth from '../components/Auth'
import SubscriptionProcessing from '../pages/SubscriptionProcessing';
import ConfirmationPage from "../pages/ConfirmationPage";
import PromoAuth from '../pages/Promo/PromoAuth'
import PromoOTP from '../pages/Promo/PromoOTP'
import PromoConfirmation from '../pages/Promo/PromoConfirmation'
import PromoSubscriptionProcessing from '../pages/Promo/PromoSubscriptionProcessing'
import PromoHomePage from '../pages/Promo/PromoHomePage'
import PromoQuiz from '../pages/Promo/PromoQuiz'
import PromoGameOver from '../pages/Promo/PromoGameOver'
import PromoFindingOpponent from '../pages/Promo/PromoFindingOpponent'
import PromoProfile from '../pages/Promo/PromoProfile'
import PromoLeaderboard from '../pages/Promo/PromoLeaderboard'
import SubscriptionPage2 from '../pages/SubscriptionPage2'
import SelectPacksPage from '../pages/Promo/SelectPacksPage'

const Routes = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <SubscriptionPage />,
            errorElement: <ErrorBoundary />
        },

        {
            path: "/login",
            element: <LoginPage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/otp",
            element: <OtpPage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/low-balance",
            element: <LowBalancePage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/confirmation",
            element: <ConfirmationPage />
        },
        {
            path: "/subscription-processing",
            element: <SubscriptionProcessing />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/home",
            element: <Auth>
                <HomePage />
            </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/all-quizes",
            element: <Auth>
                <AllQuizes />
            </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/quiz-details",
            element:
                <Auth>
                    <QuizDetails />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/leaderboard",
            element: <Auth>
                <Leaderboard />
            </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/profile",
            element:
                <Auth>
                    <Profile />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/contact-us",
            element: <ContactUs />,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/policy",
            element: <Policy />,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/language",
            element: <Language />,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/edit-profile",
            element:
                <Auth>
                    <EditProfile />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/history",
            element:
                <Auth>
                    <History />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/finding-opponent",
            element:
                <Auth>
                    <FindingOpponent />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/game",
            element:
                <Auth>
                    <Game />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/game-over",
            element: <GameOver />,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/reverse-quiz",
            element:
                <Auth>
                    <ReverseQuizPage />
                </Auth>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/reverse-quiz/finding-opponent",
            element:
                <Auth>
                    <FindingOpponentReverseQuiz />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/reverse-quiz/game",
            element:
                <Auth>
                    <ReverseQuizGame />
                </Auth>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/reverse-quiz/game-over",
            element: <ReverseQuizGameOver />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/auth",
            element: <PromoAuth />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/otp",
            element: <PromoOTP />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/confirmation",
            element: <PromoConfirmation />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/subscription-processing",
            element: <PromoSubscriptionProcessing />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/home",
            element:
                <Auth>
                    <PromoHomePage />
                </Auth>
            ,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/finding-opponent",
            element: <Auth>
                <PromoFindingOpponent />
            </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/game",
            element: <Auth>
                <PromoQuiz />
            </Auth>
        },
        {
            path: "/promo/game-over",
            element: <Auth>
                <PromoGameOver />
            </Auth>,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/profile",
            element: <PromoProfile />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/leaderboard",
            element: <PromoLeaderboard />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/promo/select-packs",
            element: <SelectPacksPage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "*",
            element: <Navigate to="/" />
        }
    ])
    return (
        <RouterProvider router={router} />
    )
}

export default Routes